/**
 * The autoTemplate module automatically searches the DOM tree at init for templating instructions;
 * allows us to use templates without views.
 *
 * @module autoTemplate
 */
import CoreView from '@netx/core/lib/netx-view';

import LoadingSpinnerTemplate from './templates/loading-spinner.html';
import SystemHeaderTemplate from './templates/system-header.html';
const Templates = {
	'loading-spinner': LoadingSpinnerTemplate,
	'system-header': SystemHeaderTemplate,
};

import customConfig from './config';

import routes from './routes';

/**
 * AutoTemplate init handler
 * @event
 * @param {object} options Options
 * @fires module:autoTemplate#autoTemplate:extend
 * @fires module:autoTemplate#autoTemplate:initialized
 */
dispatcher.once('autoTemplate:init', function (options) {
	// Check for module options
	options = _.extend({}, customConfig, options);

	var NS = (Netx.autoTemplate = {
		options: options,
		templates: Templates,
		views: {},
	});

	/**
	 * AutoTemplates are a method to include templates directly from other templates,
	 * in order to break apart templates into useful chunks.
	 * @event module:autoTemplate#autoTemplate:scan
	 * @param {object} context jQuery object
	 */
	dispatcher.on('autoTemplate:scan', function (context) {
		// Search the DOM for divs with '.nx-autotemplate'
		var target = context
			? context.find('.nx-autotemplate')
			: $('.nx-autotemplate');

		// For each of those, attempt to load a template
		target.each(function (i, el) {
			NS.views[el.id] && NS.views[el.id].remove();

			// Look for custom template - similar to netx-view.js 1028
			var templateName = el.getAttribute('data-nx-template');
			if (templateName == null) {
				templateName = el.id;
			}

			//templateRoot changed to 'core/' as all templates are now grunted to core folder
			var v = (NS.views[el.id] = new CoreView({
				el: el,
				id: '#' + el.id,
				template: NS.templates[templateName],
			}));

			// If successful, render & install in the DOM
			v && v.render();
		});
	});

	// Finish init & don't do it again.
	dispatcher.trigger('autoTemplate:extend', NS);

	// check the entire DOM for autoTemplate instructions now.
	dispatcher.trigger('autoTemplate:scan');

	dispatcher.trigger('autoTemplate:initialized', NS);
});

export default {
	initialize(opts) {
		return new Promise((resolve, reject) => {
			dispatcher.once('autoTemplate:initialized', () => {
				resolve(routes);
			});
			dispatcher.trigger('autoTemplate:init');
		});
	},
};
